import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: null,
  email : null,
  expiresAt: null,
};

const accessTokenSlice = createSlice({
  name: 'accessToken',
  initialState,
  reducers: {
    setAccessToken(state, action) {
      state.token = action.payload; // Assuming action.payload is the access token
      
    },
    setEmail(state, action) {
      state.email = action.payload; // Assuming action.payload is the email
    },
    setExpiresAt(state, action) {
      state.expiresAt = action.payload; // Set the expiresAt value
    },
    clearAccessToken(state) {
      state.token = null; // Optionally, for logging out
      state.email = null;
      state.expiresAt = null; // Clear expiresAt when logging out
    },
  },
});

export const { setAccessToken, setEmail, setExpiresAt, clearAccessToken } = accessTokenSlice.actions;
export default accessTokenSlice.reducer;
